import React from 'react';
import { useTranslation } from 'react-i18next';

interface InformationCardContentDescriptionProps {
  description: string;
}

const InformationCardContentDescription: React.FC<InformationCardContentDescriptionProps> = ({ description }) => {
  const { t } = useTranslation();
  return <div className="paragraph">{t(description)}</div>;
};

export default InformationCardContentDescription; 